<template>
  <div class="viewBoard">
    <!-- 客服 -->
    <view-ke-fu v-if="this.security.hasAuth('viewBoard_kf')"></view-ke-fu>

    <!-- 管理员 -->
    <view-guan-li v-if="this.security.hasAuth('viewBoard_gly')"></view-guan-li>

    <!-- 项目经理-->
    <view-jing-li v-if="this.security.hasAuth('viewBoard_xmjl')"></view-jing-li>

    <!-- 总监 -->
    <view-zong-jian v-if="this.security.hasAuth('viewBoard_zj')"></view-zong-jian>

    <div style="height: 10px;"></div>
  </div>
</template>

<script>
import ViewKeFu from './viewKeFu'
import ViewGuanLi from './viewGuanLi'
import ViewZongJian from './viewZongJian'
import ViewJingLi from './viewJingLi'

/**
 * @typedef {'kefu' | 'guanLi' | 'zongJian' | 'jingLi'} IRoleId 角色标识；用于看板组件可能与系统配置不一致
 * - keFu 客服
 * - guanLi 管理
 * - zongJian 项目总监
 * - jingLi 项目经理
 */

/**
 * 看板
 */
export default {
  name: 'viewBoard',
  components: { ViewKeFu, ViewGuanLi, ViewZongJian, ViewJingLi },
  data() {
    return {
      role: 'keFu'
    }
  },
  methods: {}
}
</script>

<style lang="postcss">
.viewBoard {
  padding: 9px 20px;
  height: 100%;
  overflow:hidden;
  overflow-y: auto;
  box-sizing: border-box;

  & .space-item + .space-item {
    margin-left: 10px;
    cursor: pointer;
  }

  /* 模块标题 */
  & .m-title {
    margin-top: 8px;
    position: relative;
    padding-left: 11px;
    font-size: 14px;
    color: #333;
    line-height: 32px;

    &::before {
      content: '';
      display: inline-block;
      margin: auto;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      height: 14px;
      border-left: 2px solid #00a0e9;
    }
  }

  & .card-row {
    display: flex;
    /* align-items: center; */

    & .row-col {
      flex: 1;
      width: 0;
    }
  }

  & .board-box {
    position: relative;
    /* 临时代码 */
    background: #fff;
    border-radius: 8px;
    height: 260px;
    /* text-align: center; */
  }

  & .chart1 {
    width: 100%;
    height: 100%;
    /* 纠正 tooltip 文字方向 */
    text-align: left;
  }

  & .chart-table {
    & .board-box {
      padding: 10px;
      height: auto;
      overflow: hidden;

      & .layui-table-view {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/index.vue